import LogoGray from "images/logos/tonatrenujes-gray.svg?url";
import LogoMaturitaGray from "images/logos/tonatrenujes-maturita-gray.svg?url";

import { useAppSelector } from "store/hooks";
import { getGrade } from "store/slices/user";

const Footer = () => {
  const grade = useAppSelector(getGrade);
  const isGraduate = grade === "maturant";

  return (
    <footer className="footer">
      <a href="https://zona.to-das.cz/_u_home-schooling-buy.php" target="__blank" rel="noreferrer noopener">
        <img
          src={isGraduate ? LogoMaturitaGray : LogoGray}
          alt={isGraduate ? "To dáš! Maturita nanečisto" : "To dáš! Přijímačky nanečisto"}
        />
      </a>
    </footer>
  );
};

export default Footer;
